import React from 'react';
import ItemRightTableList from './ItemRightTableList';
import { IPostCardProps } from '@/interfaces/card';

interface IRightTableList {
  title?: string;
  data?: IPostCardProps[];
}

const RightTableList = ({ data, title }: IRightTableList) => {
  return (
    <div className="rounded-xl bg-[#E4E4E4] p-5 w-full">
      <div className="text-center text-[24px] font-bold pb-4">{title}</div>
      <div className="flex flex-col gap-4">
        {data?.map((item, index) => (
          <ItemRightTableList key={index} {...item} />
        ))}
      </div>
    </div>
  );
};

export default RightTableList;
